module.exports = __webpack_public_path__ + "img/logo2.2fece66f.png";